import { Horizontal, MaterialIcon, Texto } from '@gravitate-js/excalibrr'
import type React from 'react'

interface CounterpartyCellRendererProps {
  value: string
}

export const CounterpartyCellRenderer: React.FC<CounterpartyCellRendererProps> = ({ value }) => {
  return (
    <Horizontal style={{ overflow: 'visible' }} gap={8} verticalCenter>
      <MaterialIcon icon='store' style={{ color: 'var(--theme-color-2)' }} />
      <Texto>{value || 'N/A'}</Texto>
    </Horizontal>
  )
}
